/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * Preferences
 *
 */

import React, { memo, useState, useEffect, useRef, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import {
  Button,
  Conditional,
  RadioGroup,
  ShimmerTag,
  Space,
  Text,
  InputWithCounter,
  InputWithSuffix,
  Modal,
  ModalContent,
  ModalHeader,
  Cross,
  RadioButton,
  Paper,
  Grid,
  Column,
  Toggle,
} from '@cashfree-intl/coherent';
import { usePermissionCode } from '@cashfree-intl/auth';

import { MerchantDetailsContext } from 'contexts/MerchantDetailsContext';
import WithReadPermissions from 'components/WithReadPermission';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { INSTANT_REFUNDS_URL, PGDB_SHOW_REFUNDS_V2 } from 'utils/constants';
import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';
import InstantRefundActivationModal from 'containers/Payments/components/InstantRefundActivationModal';
import { PERM_CODES } from 'constants/permCodes';
import makeSelectPreferences from './selectors';
import reducer from './reducer';
import saga from './saga';

import {
  enableLoaderAction,
  disableLoaderAction,
  getPreferencesDataAction,
  setOrderExpiryTimeAction,
  setTransactionCompleteTimeAction,
  merchantIrConfigAction,
  updateDefaultRefundSpeedAction,
  updateNotificationGroupAction,
} from './actions';

import CustomIcon from '../../components/CustomIcons';
import Loader from '../../components/Loader';
import useClickOutside from '../../utils/hooks';
import {
  PROCESSING_FEE_MODAL,
  DEFAULT_REFUND_SPEED,
  MERCHANT_EMAIL_ENABLED,
  INACTIVE,
  ACTIVE,
  INSTANT_REFUNDS,
} from './constants';

import { MerchantContext } from '../../contexts/MerchantContext';

export function Preferences(props) {
  useInjectReducer({ key: 'preferences', reducer });
  useInjectSaga({ key: 'preferences', saga });

  const {
    instantRefundsFreeTrialEligibility = {},
    featureToggles = {},
    isVbaEnabled,
  } = useContext(MerchantContext);
  const { merchantDetails } = useContext(MerchantDetailsContext);
  const hasViewPermission = usePermissionCode(
    PERM_CODES.PG_CHECKOUTPREFERENCES_VIEW,
  );
  const hasUpdatePermission = usePermissionCode(
    PERM_CODES.PG_ALLCHECKOUTPREFERENCES_UPDATE,
  );

  const envObj = process.env;

  const [searchParams] = useSearchParams();
  const { env = '' } = Object.fromEntries(searchParams);

  const showRefundsV2 =
    ['development', 'gamma'].includes(envObj.NODE_ENV) ||
    (PGDB_SHOW_REFUNDS_V2 in featureToggles &&
      featureToggles[PGDB_SHOW_REFUNDS_V2]);

  const [expandItems, resetExpandItems] = useState({
    ORDER: true,
    TRANSACTION: false,
  });
  const [isOrderExpiryValid, resetOrderExpiryValid] = useState(false);
  const [isTTLValid, resetTTLValid] = useState(false);
  const [orderExpiryData, resetOrderExpiryData] = useState({
    orderExpiryRadio: 'orderExpiryDays',
    orderExpiryDays: '',
    orderExpiryTime: {
      orderExpiryHours: '',
      orderExpiryMins: '',
    },
  });
  const [transactionCompleteTime, resetTransactionCompleteTime] = useState({
    transactionCompleteHours: '',
    transactionCompleteMins: '',
  });

  const [modalDisplay, setModalDisplay] = useState();
  const [showRefundSpeedOptions, setShowRefundSpeedOption] = useState(false);
  const [refundType, setRefundType] = useState();
  const [isNotifGroupPost, setNotifGroupPost] = useState(true);
  const [notifConfigValue, setConfigValue] = useState(INACTIVE);
  const [isDefaultRefundSpeedPresent, setDefaultRefundSpeedPresent] = useState(
    false,
  );

  const {
    enableLoader,
    disableLoader,
    getPreferencesData,
    setOrderExpiryTime,
    setTransactionCompleteTime,
    preferences: { isLoading },
    merchantIrConfig,
    updateDefaultRefundSpeed,
    updateNotificationGroup,
  } = props;

  const handleExpandItems = key => {
    resetExpandItems({
      ...expandItems,
      [key]: !expandItems[key],
    });
  };

  const modalRef = useRef(null);

  const handleCloseModal = () => {
    setModalDisplay();
  };

  useClickOutside(modalRef, handleCloseModal);

  const getModifiedPreferencesData = data => {
    const { orderExpiry } = data[0];
    const { transactionCompletionTimeMins } = data[1];
    const modifiedOrderExpiry = parseInt(orderExpiry, 10);
    if (
      (orderExpiry === '' || Number.isNaN(modifiedOrderExpiry)) &&
      transactionCompletionTimeMins === ''
    ) {
      disableLoader();
      return;
    }
    if (orderExpiry !== '' && !Number.isNaN(modifiedOrderExpiry)) {
      if (modifiedOrderExpiry % 1440 === 0) {
        resetOrderExpiryData({
          orderExpiryRadio: 'orderExpiryDays',
          orderExpiryDays: `${modifiedOrderExpiry / 1440}`,
          orderExpiryTime: {
            orderExpiryHours: '',
            orderExpiryMins: '',
          },
        });
      } else {
        resetOrderExpiryData({
          orderExpiryRadio: 'orderExpiryTime',
          orderExpiryDays: '',
          orderExpiryTime: {
            orderExpiryHours:
              Math.trunc(modifiedOrderExpiry / 60) < 10
                ? `0${Math.trunc(modifiedOrderExpiry / 60)}`
                : `${Math.trunc(modifiedOrderExpiry / 60)}`,
            orderExpiryMins:
              modifiedOrderExpiry % 60 < 10
                ? `0${modifiedOrderExpiry % 60}`
                : `${modifiedOrderExpiry % 60}`,
          },
        });
      }
      resetOrderExpiryValid(true);
    }
    if (transactionCompletionTimeMins !== '') {
      resetTransactionCompleteTime({
        transactionCompleteHours:
          Math.trunc(transactionCompletionTimeMins / 60) < 10
            ? `0${Math.trunc(transactionCompletionTimeMins / 60)}`
            : `${Math.trunc(transactionCompletionTimeMins / 60)}`,
        transactionCompleteMins:
          transactionCompletionTimeMins % 60 < 10
            ? `0${transactionCompletionTimeMins % 60}`
            : `${transactionCompletionTimeMins % 60}`,
      });
      resetTTLValid(true);
    }
    disableLoader();
  };

  useEffect(() => {
    enableLoader();
    getPreferencesData({ cb: getModifiedPreferencesData });
  }, [env]);

  const getOrderExpiryValid = ({ name, value }) => {
    const {
      orderExpiryDays,
      orderExpiryTime: { orderExpiryHours, orderExpiryMins },
    } = orderExpiryData;
    const orderExpiryDaysInt = orderExpiryDays
      ? parseInt(orderExpiryDays, 10)
      : '';
    const orderExpiryHoursInt = orderExpiryHours
      ? parseInt(orderExpiryHours, 10)
      : '';
    const orderExpiryMinsInt = orderExpiryMins
      ? parseInt(orderExpiryMins, 10)
      : '';
    switch (name) {
      case 'orderExpiryDays': {
        return (
          parseInt(value, 10) >= 1 &&
          parseInt(value, 10) <= 30 &&
          !/\./.test(value)
        );
      }
      case 'orderExpiryHours': {
        return (
          ((parseInt(value, 10) === 0 &&
            orderExpiryMinsInt >= 5 &&
            orderExpiryMinsInt < 60) ||
            (parseInt(value, 10) > 0 &&
              parseInt(value, 10) < 24 &&
              orderExpiryMinsInt !== '' &&
              orderExpiryMinsInt >= 0 &&
              orderExpiryMinsInt < 60)) &&
          !/\./.test(value) &&
          !/\./.test(orderExpiryMins)
        );
      }
      case 'orderExpiryMins': {
        return (
          ((orderExpiryHoursInt === 0 &&
            parseInt(value, 10) >= 5 &&
            parseInt(value, 10) < 60) ||
            (orderExpiryHoursInt > 0 &&
              orderExpiryHoursInt < 24 &&
              parseInt(value, 10) >= 0 &&
              parseInt(value, 10) < 60)) &&
          !/\./.test(orderExpiryHours) &&
          !/\./.test(value)
        );
      }
      default: {
        if (value === 'orderExpiryDays')
          return (
            orderExpiryDaysInt >= 1 &&
            orderExpiryDaysInt <= 30 &&
            !/\./.test(orderExpiryDays)
          );
        return (
          ((orderExpiryHoursInt === 0 &&
            orderExpiryMinsInt >= 5 &&
            orderExpiryMinsInt < 60) ||
            (orderExpiryHoursInt > 0 &&
              orderExpiryHoursInt < 24 &&
              orderExpiryMinsInt !== '' &&
              orderExpiryMinsInt >= 0 &&
              orderExpiryMinsInt < 60)) &&
          !/\./.test(orderExpiryHours) &&
          !/\./.test(orderExpiryMins)
        );
      }
    }
  };

  const handleOrderExpiryDataChange = (e, data) => {
    if (data.name === 'orderExpiryRadio' || data.name === 'orderExpiryDays') {
      resetOrderExpiryData({
        ...orderExpiryData,
        [data.name]: data.value,
      });
    } else {
      resetOrderExpiryData({
        ...orderExpiryData,
        orderExpiryTime: {
          ...orderExpiryData.orderExpiryTime,
          [data.name]: data.value,
        },
      });
    }
    // resetOrderExpiryValid(getOrderExpiryValid(data));
  };

  const daysRadioSelected =
    orderExpiryData.orderExpiryRadio === 'orderExpiryDays';

  const timeRadioSelected =
    orderExpiryData.orderExpiryRadio === 'orderExpiryTime';

  const handleInputIconClick = key => {
    if (
      (parseInt(orderExpiryData.orderExpiryDays || 0, 10) >= 30 &&
        key === 'ADD') ||
      (parseInt(orderExpiryData.orderExpiryDays || 0, 10) <= 1 &&
        key === 'SUBTRACT') ||
      !daysRadioSelected
    )
      return;
    const updatedOrderExpiryDays =
      key === 'ADD'
        ? parseInt(Number(orderExpiryData.orderExpiryDays) || 0, 10) + 1
        : parseInt(Number(orderExpiryData.orderExpiryDays), 10) - 1;
    resetOrderExpiryData({
      ...orderExpiryData,
      orderExpiryDays: `${updatedOrderExpiryDays}`,
    });
    resetOrderExpiryValid(
      getOrderExpiryValid({
        name: 'orderExpiryDays',
        value: `${updatedOrderExpiryDays}`,
      }),
    );
  };

  const inputErrorBorder =
    orderExpiryData.orderExpiryRadio === 'orderExpiryDays' &&
    orderExpiryData.orderExpiryDays !== '' &&
    !isOrderExpiryValid;

  const timeInputError =
    orderExpiryData.orderExpiryRadio === 'orderExpiryTime' &&
    (orderExpiryData.orderExpiryTime.orderExpiryHours !== '' ||
      orderExpiryData.orderExpiryTime.orderExpiryMins !== '') &&
    !isOrderExpiryValid;

  const renderOrderExpiryTime = () => (
    <div className="preferences-wrapper">
      <div className="preferences-header">
        <div className="text-dark medium-text w-600 preferences-user-select">
          Order Expiry Time
        </div>
        <div
          data-testId="order-div"
          onClick={() => handleExpandItems('ORDER')}
          className="preferences-chevron-icon"
          data-event-name="Form_Preference_Order_Icon_Expand"
          data-ignore-inner-text="true"
        >
          <CustomIcon
            componentName="CHEVRONDOWN"
            direction={expandItems.ORDER ? 'up' : 'down'}
          />
        </div>
      </div>
      <div className="medium-text w-400 preferences-text">
        Set a maximum time beyond which you do not want to accept payments for
        your orders.
      </div>
      <Conditional if={expandItems.ORDER}>
        <div className="order-expiry-wrapper">
          <div className="order-expiry-day">
            <RadioButton
              name="orderExpiryRadio"
              value="orderExpiryDays"
              checked={daysRadioSelected}
              onChange={handleOrderExpiryDataChange}
              label="No. of Days"
            />
            <div className="order-expiry-input-wrapper">
              <InputWithCounter
                name="orderExpiryDays"
                value={orderExpiryData.orderExpiryDays}
                onChange={handleOrderExpiryDataChange}
                className="order-expiry-input-day"
                errorBorder={inputErrorBorder}
                disabled={!daysRadioSelected}
                handleAddClick={() => handleInputIconClick('ADD')}
                handleSubtractClick={() => handleInputIconClick('SUBTRACT')}
                handleInputIconClick={handleInputIconClick}
                disableMinus={
                  !daysRadioSelected ||
                  parseInt(Number(orderExpiryData.orderExpiryDays) || 0, 10) <=
                    1
                }
                disablePlus={
                  !daysRadioSelected ||
                  parseInt(orderExpiryData.orderExpiryDays || 0, 10) >= 30
                }
                error={inputErrorBorder}
                errorMessage="No. should be between 1 and 30"
              />
            </div>
          </div>
          <div className="preferences-time-wrapper">
            <RadioButton
              name="orderExpiryRadio"
              value="orderExpiryTime"
              checked={timeRadioSelected}
              onChange={handleOrderExpiryDataChange}
              label="Set Time (Less than 24hrs)"
            />
            <div className="order-expiry-input-wrapper preference-set-time-warpper ">
              <InputWithSuffix
                type="number"
                name="orderExpiryHours"
                value={orderExpiryData.orderExpiryTime.orderExpiryHours}
                onChange={handleOrderExpiryDataChange}
                className={`preferences-time ${
                  timeInputError ? 'error_border' : ''
                }`}
                disabled={!timeRadioSelected}
                label={<span className="ml--2">hours</span>}
                labelPosition="right"
              />
              <span className="normal-text w-600 preferences-colon">:</span>
              <InputWithSuffix
                type="number"
                name="orderExpiryMins"
                value={orderExpiryData.orderExpiryTime.orderExpiryMins}
                onChange={handleOrderExpiryDataChange}
                className={`preferences-time ${
                  timeInputError ? 'error_border' : ''
                }`}
                disabled={!timeRadioSelected}
                label={<span>mins</span>}
                labelPosition="right"
              />
            </div>
            <Conditional if={timeInputError}>
              <div className="preferences-error">
                Time should be between 5 mins and 24 hrs
              </div>
            </Conditional>
          </div>
        </div>
      </Conditional>
    </div>
  );

  const getTTLValid = ({ name, value }) => {
    let {
      transactionCompleteHours,
      transactionCompleteMins,
    } = transactionCompleteTime;
    let transactionCompleteHoursInt = parseInt(transactionCompleteHours, 10);
    let transactionCompleteMinsInt = parseInt(transactionCompleteMins, 10);
    if (name === 'transactionCompleteHours') {
      transactionCompleteHours = value;
      transactionCompleteHoursInt = parseInt(value, 10);
    }
    if (name === 'transactionCompleteMins') {
      transactionCompleteMins = value;
      transactionCompleteMinsInt = parseInt(value, 10);
    }
    return (
      ((transactionCompleteHoursInt === 0 &&
        transactionCompleteMinsInt >= 10 &&
        transactionCompleteMinsInt < 60) ||
        (transactionCompleteHoursInt > 0 &&
          transactionCompleteHoursInt < 24 &&
          transactionCompleteMinsInt >= 0 &&
          transactionCompleteMinsInt < 60) ||
        (transactionCompleteHoursInt === 24 &&
          transactionCompleteMinsInt === 0)) &&
      !/\./.test(transactionCompleteHours) &&
      !/\./.test(transactionCompleteMins)
    );
  };

  const handleTTLChange = (e, data) => {
    resetTransactionCompleteTime({
      ...transactionCompleteTime,
      [data.name]: data.value,
    });
    resetTTLValid(getTTLValid(data));
  };

  const renderTTL = () => (
    <div className="preferences-wrapper">
      <div className="preferences-header">
        <div className="text-dark medium-text w-600 preferences-user-select">
          Transaction Complete Time
        </div>
        <div
          data-testId="transaction-div"
          onClick={() => handleExpandItems('TRANSACTION')}
          className="preferences-chevron-icon"
          data-event-name="Form_Preference_Transaction_Icon_Expand"
          data-ignore-inner-text="true"
        >
          <CustomIcon
            componentName="CHEVRONDOWN"
            direction={expandItems.TRANSACTION ? 'up' : 'down'}
          />
        </div>
      </div>
      <div className="medium-text w-400 preferences-text">
        Set a maximum time you want to wait for transactions to be complete. If
        transactions do not reach a terminal state within this time, they will
        be marked as user dropped.
      </div>
      <Conditional if={expandItems.TRANSACTION}>
        <div className="preferences-time-wrapper">
          <div className="preferences-user-select">Set Time</div>
          <div className="preference-set-time-warpper">
            <InputWithSuffix
              type="number"
              name="transactionCompleteHours"
              value={transactionCompleteTime.transactionCompleteHours}
              onChange={handleTTLChange}
              className={`preferences-time ${
                !isTTLValid ? 'error_border' : ''
              }`}
              label={<span className="ml--2">hours</span>}
              labelPosition="right"
            />
            <span className="normal-text w-600 preferences-colon">:</span>
            <InputWithSuffix
              type="number"
              name="transactionCompleteMins"
              value={transactionCompleteTime.transactionCompleteMins}
              onChange={handleTTLChange}
              className={`preferences-time ${
                !isTTLValid ? 'error_border' : ''
              }`}
              label={<span>mins</span>}
              labelPosition="right"
            />
          </div>
          <Conditional if={!isTTLValid}>
            <div className="preferences-error">
              Time should be between 10 mins and 24 hrs
            </div>
          </Conditional>
        </div>
      </Conditional>
    </div>
  );

  const handleSaveChanges = () => {
    Analytics.track(EVENTS.PREFERENCES.SAVE_CHANGES);
    enableLoader();
    if (
      daysRadioSelected &&
      getOrderExpiryValid({
        name: 'orderExpiryDays',
        value: orderExpiryData.orderExpiryDays,
      })
    ) {
      setOrderExpiryTime({
        data: {
          orderExpiry: `${parseInt(orderExpiryData.orderExpiryDays, 10) *
            1440}`,
        },
        cb: getModifiedPreferencesData,
      });
    } else if (
      timeRadioSelected &&
      getOrderExpiryValid({
        name: 'orderExpiryRadio',
        value: 'orderExpiryTime',
      })
    ) {
      const orderExpiryValue =
        parseInt(orderExpiryData.orderExpiryTime.orderExpiryHours, 10) * 60 +
        parseInt(orderExpiryData.orderExpiryTime.orderExpiryMins, 10);
      setOrderExpiryTime({
        data: {
          orderExpiry: `${orderExpiryValue}`,
        },
        cb: getModifiedPreferencesData,
      });
    } else {
      resetOrderExpiryValid(false);
      disableLoader();
    }
    if (
      getTTLValid({
        name: '',
        value: '',
      })
    ) {
      const transactionCompleteTimeValue =
        parseInt(transactionCompleteTime.transactionCompleteHours, 10) * 60 +
        parseInt(transactionCompleteTime.transactionCompleteMins, 10);
      setTransactionCompleteTime({
        data: {
          transactionCompletionTimeMins: `${transactionCompleteTimeValue}`,
        },
        cb: getModifiedPreferencesData,
      });
    } else {
      resetTTLValid(false);
      disableLoader();
    }
    if (showRefundSpeedOptions) {
      updateDefaultRefundSpeed({
        configKey: DEFAULT_REFUND_SPEED,
        configValue: refundType,
        isDefaultRefundSpeedPresent,
      });
    }
    if (isVbaEnabled) {
      if (isNotifGroupPost) {
        updateNotificationGroup({
          method: 'POST',
          body: {
            configKey: 'MERCHANT_EMAIL_ENABLED',
            configValue: notifConfigValue,
          },
        });
      } else {
        updateNotificationGroup({
          method: 'PATCH',
          body: {
            configKey: 'MERCHANT_EMAIL_ENABLED',
            configValue: notifConfigValue,
          },
        });
      }
    }
  };

  const radioData = {
    radioOptions: [
      {
        label: () => (
          <label>
            <Space direction="column" gap={1}>
              <Text variant="b14">Standard Refund</Text>
              <Text variant="b12" color="bodyLight">
                Refund will be processed within 5-7 working days.
              </Text>
            </Space>
          </label>
        ),
        name: 'refundType',
        value: 'STANDARD',
      },
      {
        label: () => (
          <label>
            <Space direction="column" gap={1}>
              <Space gap={1} alignItems="flex-start">
                <Text variant="b14">Instant Refund</Text>
                <ShimmerTag>new</ShimmerTag>
              </Space>
              <Space>
                <Text variant="b12" color="bodyLight" className="mr-1">
                  Refunds are processed instantly.{' '}
                </Text>
              </Space>
            </Space>
          </label>
        ),
        name: 'refundType',
        value: 'INSTANT',
      },
    ],
  };

  const getMerchantIrConfig = () =>
    merchantIrConfig({
      configKey: DEFAULT_REFUND_SPEED,
      cb: res => {
        if (res && res.length) {
          setDefaultRefundSpeedPresent(true);
          const resObjArr = res.filter(
            obj => obj.configKey === DEFAULT_REFUND_SPEED,
          );
          if (resObjArr.length) setRefundType(resObjArr[0].configValue);
          else setRefundType('STANDARD');
        } else {
          setRefundType('STANDARD');
          setDefaultRefundSpeedPresent(false);
        }
      },
    });

  useEffect(() => {
    merchantIrConfig({
      configKey: INSTANT_REFUNDS,
      cb: response => {
        if (response && response.length) {
          const respObjArr = response.filter(
            obj => obj.configKey === INSTANT_REFUNDS,
          );
          if (
            (respObjArr.length && respObjArr[0].configValue === 'ACTIVE') ||
            showRefundsV2
          ) {
            setShowRefundSpeedOption(true);
            getMerchantIrConfig();
          } else setShowRefundSpeedOption(false);
        } else if (showRefundsV2) {
          setShowRefundSpeedOption(true);
          getMerchantIrConfig();
        } else setShowRefundSpeedOption(false);
      },
    });
    merchantIrConfig({
      configKey: MERCHANT_EMAIL_ENABLED,
      cb: response => {
        if (!response.length) {
          setNotifGroupPost(true);
          setConfigValue(INACTIVE);
        } else {
          setNotifGroupPost(false);
          setConfigValue(response[0].configValue);
        }
      },
    });
  }, [env]);

  const handleOptionalRadioOptions = obj => ({
    ...obj,
    checked: refundType === obj.value,
    onChange: () => {
      setRefundType(obj.value);
    },
  });

  const renderSetRefundSpeed = () => (
    <div className="preferences-wrapper">
      <div className="preferences-header">Refund Speed</div>
      <div className="medium-text w-400 preferences-text">
        Set the default refund speed. This is the speed at which the refunds are
        processed for your customers.
        <a href={INSTANT_REFUNDS_URL} target="_blank" className="px-1">
          Know more
        </a>
      </div>
      <Space>
        <RadioGroup
          radioOptions={radioData.radioOptions.map(handleOptionalRadioOptions)}
        />
        <Text
          variant="b12"
          color="primary"
          onClick={() => {
            setModalDisplay(PROCESSING_FEE_MODAL);
          }}
          className="processing-fee"
          data-event-name="Link_CheckProcessingFee"
        >
          {' '}
          Check Processing Fee
        </Text>
      </Space>
    </div>
  );

  const handleEnableIr = () => {
    handleCloseModal();
    setRefundType('INSTANT');
  };

  const handleOnToggle = () => {
    setConfigValue(prop => (prop === INACTIVE ? ACTIVE : INACTIVE));
  };

  if (!hasViewPermission) {
    return (
      <WithReadPermissions
        description="to access checkout preferences"
        merchantEmail={merchantDetails.merchantEmail}
      />
    );
  }

  return (
    <div>
      <div className="preferences-container">
        <Loader active={isLoading} />
        <Button
          primary
          className="save-changes-btn"
          onClick={handleSaveChanges}
          disabled={!isOrderExpiryValid || !isTTLValid || !hasUpdatePermission}
          data-event-name="Primary_Button_SaveChanges"
        >
          Save Changes
        </Button>
        {renderOrderExpiryTime()}
        {renderTTL()}
        <Conditional if={showRefundSpeedOptions}>
          {renderSetRefundSpeed()}
        </Conditional>
      </div>
      <div>
        <Conditional if={modalDisplay === PROCESSING_FEE_MODAL}>
          <Conditional if={!showRefundsV2}>
            <Modal open className="fee" ref={modalRef}>
              <ModalHeader>
                Instant Refund Fee{' '}
                <Cross
                  data-testId="cross"
                  onClick={handleCloseModal}
                  data-event-name="Form_Preferences_Icon_Close"
                  data-ignore-inner-text="true"
                />
              </ModalHeader>
              <ModalContent>
                <Text variant="b14" color="bodyLight" className="mb-2">
                  Cashfree Payments charges a small fee for processing instant
                  refunds.(The processing fee listed are indicative, and the
                  final amount might change.)
                </Text>
                <div>
                  <Space
                    direction="column"
                    gap={1}
                    className="fee-space px-2 py-2"
                  >
                    <Space justifyContent="space-between">
                      <Text variant="b12" strong>
                        Refund Amount
                      </Text>
                      <Text variant="b12" strong>
                        Processing Fee
                      </Text>
                    </Space>
                    <Space justifyContent="space-between">
                      <Text variant="b12" color="bodyLight">
                        ₹ 0 - ₹ 1,000
                      </Text>
                      <Text variant="b12" color="bodyLight">
                        ₹ 10
                      </Text>
                    </Space>
                    <Space justifyContent="space-between">
                      <Text variant="b12" color="bodyLight">
                        ₹ 1,001 - ₹ 25,000
                      </Text>
                      <Text variant="b12" color="bodyLight">
                        ₹ 15
                      </Text>
                    </Space>
                    <Space justifyContent="space-between">
                      <Text variant="b12" color="bodyLight">
                        ₹ 25,001 and above
                      </Text>
                      <Text variant="b12" color="bodyLight">
                        ₹ 18
                      </Text>
                    </Space>
                  </Space>
                </div>
                <Button
                  className="ir-button mt-3"
                  primary
                  onClick={handleEnableIr}
                  data-event-name="Primary_Button_EnableInstantRefund"
                >
                  Enable Instant Refund
                </Button>
              </ModalContent>
            </Modal>
          </Conditional>
          <Conditional if={showRefundsV2}>
            <InstantRefundActivationModal
              data={instantRefundsFreeTrialEligibility}
              onConfirm={handleEnableIr}
              closeModal={handleCloseModal}
            />
          </Conditional>
        </Conditional>
      </div>

      <Conditional if={isVbaEnabled}>
        <Paper>
          <Grid columns={16} verticalAlign="middle">
            <Column width={14}>
              <Text variant="b14" strong>
                Email to notification groups
              </Text>
              <Text variant="b14" color="bodyLight" className="mt-2">
                Send email to the notification group when payment is received
              </Text>
            </Column>
            <Column width={2} textAlign="right">
              <Toggle
                active={notifConfigValue === 'ACTIVE'}
                onToggle={handleOnToggle}
              />
            </Column>
          </Grid>
        </Paper>
      </Conditional>
    </div>
  );
}

Preferences.propTypes = {
  preferences: PropTypes.object.isRequired,
  enableLoader: PropTypes.func.isRequired,
  disableLoader: PropTypes.func.isRequired,
  getPreferencesData: PropTypes.func.isRequired,
  setOrderExpiryTime: PropTypes.func.isRequired,
  setTransactionCompleteTime: PropTypes.func.isRequired,
  merchantIrConfig: PropTypes.func.isRequired,
  updateDefaultRefundSpeed: PropTypes.func.isRequired,
  updateNotificationGroup: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  preferences: makeSelectPreferences(),
});

function mapDispatchToProps(dispatch) {
  return {
    enableLoader: () => dispatch(enableLoaderAction()),
    disableLoader: () => dispatch(disableLoaderAction()),
    getPreferencesData: data => dispatch(getPreferencesDataAction(data)),
    setOrderExpiryTime: data => dispatch(setOrderExpiryTimeAction(data)),
    setTransactionCompleteTime: data =>
      dispatch(setTransactionCompleteTimeAction(data)),
    merchantIrConfig: data => dispatch(merchantIrConfigAction(data)),
    updateDefaultRefundSpeed: data =>
      dispatch(updateDefaultRefundSpeedAction(data)),
    updateNotificationGroup: data =>
      dispatch(updateNotificationGroupAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(Preferences);
